import React from "react";

import PageHeader, { type Props as PageHeaderProps } from "~/common/PageHeader";
import ViewportContext from "~/common/ViewportContext";
import { MobileOpenPanelButton } from "~/ui/CollapsiblePanel";

import styles from "./SettingsPageHeader.module.css";

export default function SettingsPageHeader({
	subject,
	actions,
	backButton,
	moreActions,
	mobileActions,
	...rest
}: PageHeaderProps) {
	const { isComputer } = React.useContext(ViewportContext);
	const defaultBackButton = !isComputer && <MobileOpenPanelButton />;

	return (
		<PageHeader
			className={styles.header}
			backButton={backButton || defaultBackButton}
			actions={actions}
			mobileActions={mobileActions}
			moreActions={!mobileActions ? moreActions : moreActions || []}
			subject={<div className={styles.subject}>{subject}</div>}
			{...rest}
		/>
	);
}
